import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'reactstrap';

// Finger/stylus signature on the handheld. onChange receives a PNG data URL, or "" when cleared.
const SignaturePad = ({ label, name, onChange }) => {
    const canvasRef = useRef(null);
    const drawing = useRef(false);
    const [empty, setEmpty] = useState(true);

    useEffect(() => {
        const c = canvasRef.current;
        const ratio = window.devicePixelRatio || 1;
        c.width = c.offsetWidth * ratio;
        c.height = c.offsetHeight * ratio;
        const ctx = c.getContext('2d');
        ctx.scale(ratio, ratio);
        ctx.lineWidth = 2.2;
        ctx.lineCap = 'round';
        ctx.strokeStyle = '#1b2a78';
    }, []);

    const pos = (e) => {
        const r = canvasRef.current.getBoundingClientRect();
        const p = e.touches ? e.touches[0] : e;
        return { x: p.clientX - r.left, y: p.clientY - r.top };
    };
    const start = (e) => {
        e.preventDefault();
        drawing.current = true;
        const ctx = canvasRef.current.getContext('2d');
        const { x, y } = pos(e);
        ctx.beginPath();
        ctx.moveTo(x, y);
    };
    const move = (e) => {
        if (!drawing.current) return;
        e.preventDefault();
        const ctx = canvasRef.current.getContext('2d');
        const { x, y } = pos(e);
        ctx.lineTo(x, y);
        ctx.stroke();
        setEmpty(false);
    };
    const end = () => {
        if (!drawing.current) return;
        drawing.current = false;
        onChange(canvasRef.current.toDataURL('image/png'));
    };
    const clear = () => {
        const c = canvasRef.current;
        c.getContext('2d').clearRect(0, 0, c.width, c.height);
        setEmpty(true);
        onChange('');
    };

    return (
        <div className="dt-sign">
            <div className="dt-sign-head">
                <span><b>{label}</b>{name ? `: ${name}` : ''}</span>
                <Button size="sm" color="light" onClick={clear}>Temizle</Button>
            </div>
            <canvas ref={canvasRef} className="dt-sign-canvas"
                onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
                onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
            {empty && <div className="dt-sign-hint">Buraya imza atınız</div>}
        </div>
    );
};

export default SignaturePad;
